import { UserStatus } from "@generated/CurrentUser_Query.graphql";
import { StartContentConfigType } from "@generated/NodeContentElementsList_NodeFragment.graphql";
import { selectTooltipBasedOnGlobalUserStatus } from "./selectTooltipBasedOnGlobalUserStatus";

export const selectTooltipStartContentConfigType = (
	reasonConfigTypes: readonly StartContentConfigType[] | undefined,
	globalUserStatus: UserStatus | undefined,
) => {
	if (reasonConfigTypes?.includes("StartContent_SpecificUserStatusesCan")) {
		return selectTooltipBasedOnGlobalUserStatus(globalUserStatus);
	} else {
		return "Dieser Service steht Ihnen nicht zur Verfügung.";
	}
};
